export const KEYCODES = {
  ENTER: 13,
  BACKSPACE: 8,
  ESCAPE: 27,
};
